var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariant97(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.6633C8.85652 14.6633 10.637 13.9258 11.9497 12.6131C13.2625 11.3003 14 9.51985 14 7.66333C14 5.80681 13.2625 4.02634 11.9497 2.71358C10.637 1.40083 8.85652 0.66333 7 0.66333C5.14348 0.66333 3.36301 1.40083 2.05025 2.71358C0.737498 4.02634 0 5.80681 0 7.66333C0 9.51985 0.737498 11.3003 2.05025 12.6131C3.36301 13.9258 5.14348 14.6633 7 14.6633ZM10.0898 6.37817L6.58984 9.87817C6.33281 10.1352 5.91719 10.1352 5.66289 9.87817L3.91289 8.12817C3.65586 7.87114 3.65586 7.45552 3.91289 7.20122C4.16992 6.94692 4.58555 6.94419 4.83984 7.20122L6.125 8.48638L9.16016 5.44849C9.41719 5.19145 9.83281 5.19145 10.0871 5.44849C10.3414 5.70552 10.3441 6.12114 10.0871 6.37544L10.0898 6.37817Z",
    fill: "#87A330"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.66333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant97);
export default __webpack_public_path__ + "static/media/Variant97.f21e6bcb7e3d7bb833c3f123a7d2bdac.svg";
export { ForwardRef as ReactComponent };